import i18next from "i18next";
import { isSEPACountry, isValidIBAN } from "ibantools";
import { z } from "zod";

export const ibanSchema = z
  .string()
  .refine(
    (iban) => {
      const validation = isValidIBAN(iban);
      return validation;
    },
    (value) => ({
      message: i18next.t("validation.iban.invalid", {
        defaultValue: "Invalid IBAN format",
        value: value,
      }),
    }),
  )
  .refine(
    (value) => {
      return isSEPACountry(value.slice(0, 2));
    },
    {
      message: i18next.t("validation.iban.non_sepa", {
        defaultValue: "IBAN is not SEPA-compatible",
      }),
    },
  );

export type IBANSchema = z.infer<typeof ibanSchema>;
